import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { ADMINSTRATIVE_FEE, SEASON_ENTRY_FEE } from '../utils/constants';
import { PaymentOptions } from './entries/PaymentOptions';
import { currentYear } from '../utils/date';

function Announcement(props) {

    return (
        <Modal show={props.show} onHide={() => props.setShow(false)}>
            <Modal.Header closeButton={true}>
                <Modal.Title>Announcement</Modal.Title>
            </Modal.Header>

            <Form>
                <Modal.Body>
                    {beginSeasonAnnouncement}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => props.setShow(false)}>Close</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}

const beginSeasonAnnouncement = <>
<p><strong>Are you ready for some football ?!?</strong></p>
<p>We are back for the {currentYear()} Football season.
</p>
<p>For those of you with memories as bad as mine, we have a password reset feature.
    Select "Login" in the top right and click the "Forgot Password?" link.
</p>
<p>On your first visit to the "My Entries" page, select how many entries you want to play
    for the year.  It's ${SEASON_ENTRY_FEE} dollars per entry ($5 dollars per week + $5 for bowl games + ${ADMINSTRATIVE_FEE} admin fee).
</p>
<p></p>
<p>Send money to Phil via:</p>
<PaymentOptions />
<p>Invite friends, family, and co-workers to join! Money is due by August 28th.</p>
<p>Fake good luck!!</p>
</>;

// const bowlSeasonAnnouncment = <>
//     <p><strong>Bowl Season {currentYear()} is here!!!</strong></p>
//     <p>Spreads are locked for all games and entry submissions may now begin.
//         Every entry will be required to pick 12 games against the spread and the entry with the most correct
//         picks wins. Ties will split the pot.
//     </p>
//     <p>All entries must be submitted by 10 a.m. EST on December 26th.  If picking a game that takes place before that date,
//         your entry must be submitted before the earliest picked game starts.
//     </p>
//     <p>If you need more money for the final week, make a request via the "Add Money" button in the top menu.</p>
//     <p>Send money to Phil via:</p>
//     <PaymentOptions />
//     <p>Fake good luck!!</p>
// </>;

export default Announcement;